<script>
    import { notificate } from '../../services/notification.js';
    import { form as svForm, field } from "svelte-forms";
    import { required } from 'svelte-forms/validators';
    import AssetsApi from './assets.api.js';
    import { handleAssetsUpsert } from './assets.state.svelte.js';
    import { removeTags } from '../../js/utils.js';
    import ipaddr from 'ipaddr.js';
    import { format, locale } from 'svelte-i18n';
    import MassiveActionsService from '../../services/massive-actions.js';


    let { kind = "all", handleCloseModal = (x)=>x} = $props();

    //form fields
    const assetsField = field('assets', '', [required()]);
    const kindField = field('kind', '', [required()]);
    const myForm = svForm(assetsField, kindField);

    if(kind != "all" || kind != "allWithActions"){
        $kindField.value = kind
    }

    let formData = $state({in_scope: true});
    let formIsSubmitted = false;
    // API string errors
    let APIerror = $state(null);
    // API 422 errors
    let formApiErrors = {};
    let inputElement = $state();

    let placeholder_name = {
        domain: $format("asset.kind.domain.singular") + '.xyz',
        hostname: 'hostname.' + $format("asset.kind.domain.singular").toLowerCase() + '.xyz',
        public_ip: 'n.n.n.n',
        private_ip: 'n.n.n.n',
        public_network: 'n.n.n.n/n',
        private_network: 'n.n.n.n/n',
        ad: 'ad',
        software: 'software',
        cloud: $format("asset.kind.cloud.singular").toLowerCase(),
        endpoint: 'endpoint',
        container_image: $format("asset.kind.container_image.singular"),
        email: $format("asset.kind.email.singular").toLowerCase() + "@" + $format("asset.kind.domain.singular").toLowerCase() + '.xyz'
    }

    // errors must be shown only when:
    //   field is invalid (dirty or after submit)
    //   or the API returned 422
    function shouldShowFieldError(field) {
        return (
            ((formIsSubmitted || field.dirty) && !field.valid)
            || (formApiErrors[field])
        );
    }


    const validateCIDR = async (formData, config) =>{
        //default value avoids breaking errors
        let version = "IPv4";
        let CIDR;
        let user_input;
        if(ipaddr.isValidCIDR(formData.name)){
            CIDR = ipaddr.parseCIDR(formData.name);
            if(CIDR[0].hasOwnProperty("octets")){
                version = "IPv4";
            }
            else {
                version = "IPv6";
            }
        }
        else {
            APIerror = $format("page.asset.form.errors.invalid_network");
            return false;
        }

        let address = ipaddr[version].networkAddressFromCIDR(formData.name);

        if(version == "IPv4"){
            user_input = formData.name.split(".");
            user_input = user_input[3].split("/");
            if (address.octets[3] == user_input[0]){
                return true;
            }
            else {
                let result = await notificate('confirm_network_from_ip', "modal", {network: address.octets.join("."), subnet: CIDR[1]});
                if (!result.isConfirmed) {
                    return false;
                }
                else {
                    let networkAddress = address.toString();
                    formData.name   = networkAddress + "/" + CIDR[1];
                    return true;
                }
            }
        }
        // IPv6
        else {
            address = address.toNormalizedString();
            user_input = getFullIPv6(formData.name.split("/")[0]);
            address = getFullIPv6(address.split("/")[0]);
            if(address === user_input){
                return true;
            }
            else {
                let result = await notificate('confirm_network_from_ip', "modal", {network: address, subnet: CIDR[1]});
                if (!result.isConfirmed) {
                    return false;
                }
                else {
                    let networkAddress = address.toString();
                    formData.name   = networkAddress + "/" + CIDR[1];
                    return true;
                }
            }
        }
    }

    const getFullIPv6 = (ip_string) =>{
        // replace ipv4 address if any
        let ipv4 = ip_string.match(/(.*:)([0-9]+\.[0-9]+\.[0-9]+\.[0-9]+$)/);
        if (ipv4) {
            let ip_string = ipv4[1];
            ipv4 = ipv4[2].match(/[0-9]+/g);
            for (let i = 0;i < 4;i ++) {
                let byte = parseInt(ipv4[i],10);
                ipv4[i] = ("0" + byte.toString(16)).substr(-2);
            }
            ip_string += ipv4[0] + ipv4[1] + ':' + ipv4[2] + ipv4[3];
        }

        // take care of leading and trailing ::
        ip_string = ip_string.replace(/^:|:$/g, '');

        let ipv6 = ip_string.split(':');

        for (let i = 0; i < ipv6.length; i ++) {
            let hex = ipv6[i];
            if (hex != "") {
                // normalize leading zeros
                ipv6[i] = ("0000" + hex).substr(-4);
            }
            else {
                // normalize grouped zeros ::
                hex = [];
                for (let j = ipv6.length; j <= 8; j ++) {
                    hex.push('0000');
                }
                ipv6[i] = hex.join(':');
            }
        }

        return ipv6.join(':');
    }



    async function handleSubmit() {
        event.preventDefault();
        formIsSubmitted = true;
        // reset API errors
        formApiErrors = {};

        await kindField.validate();
        await assetsField.validate();

        if ($myForm.hasError("name.required") || $myForm.hasError("kind.required")) {
            notificate('422');
            return false;
        }

        if(formData.assets) {
            let data = [];
            let assets = formData.assets.split("\n");

            if(assets.length > 100){
                return APIerror = $format("notifications.max_100");
            }

            for(let [idx, asset] of Object.entries(assets)){
                asset = {
                    name: asset,
                    description: formData.description ? formData.description : "",
                    kind       : $kindField.value,
                    in_scope: formData.in_scope
                    };
                for(let [k, v] of Object.entries(asset)){
                    if(typeof v == 'string'){
                        formData[k] = removeTags(v);
                    }
                }
                data.push(asset);
            }
            let response = await handleAssetsUpsert(data);
            let results  = response.results;
            let errors   = response.errors;
            handleCloseModal();

            //clear formData and form status and errors
            // when modal is closed after sending add request
            formData = {in_scope: true};
        }
        formIsSubmitted = false;
        formApiErrors = {};
        APIerror = null;
        return true;
    }

    const handleKeydown = event => {

        if(event.key == "Escape"){
            handleCloseModal();
        }
        else {
            return;
        }
    }
</script>
<style>
    textarea {
        min-height: 100px;
    }
    .alert.alert-warning {
        color: #856404;
        background-color: #fff3cd;
    }
</style>

<svelte:window onkeydown={handleKeydown}/>
<form role="form" novalidate onsubmit={handleSubmit}>
    <div class="card">
        <div class="card-body">
            <div class="mb-3">
                    <label for="kind">
                        {$format("page.asset.form.fields.kind")}
                        <span title="Requerido" class="text-danger">*</span></label>
                    <select
                        type="text"
                        class="form-control t-input-asset-kind"
                        id="assetAddKind"
                        name="kind"
                        bind:value={$kindField.value}
                        disabled={kind ? true : false}
                        class:is-invalid={kind && shouldShowFieldError($kindField)}
                    >
                        <option value={null} selected={!kind || kind == "all" || kind == "allWithActions"}>{$format("form.fields.select")}</option>
                        {#each AssetsApi.assets_kinds as kindProp, index}
                            <option value={kindProp.id}>{$format(`asset.kind.${kindProp.id}.singular`)}</option>
                        {/each}
                    </select>
                    {#if shouldShowFieldError($kindField)}
                        {#if $myForm.hasError('kind.required')}
                            <div class="invalid-feedback">
                                {$format("required")}
                            </div>
                        {/if}
                    {/if}
                </div>

                <div class="mb-3">
                    <label for="name">
                        {$format("asset.plural")}
                        <span title="Requerido" class="text-danger">*</span></label>
                    <textarea
                        type="text"
                        class="form-control"
                        id="assets"
                        name="assets"
                        placeholder="Activo1&#10;&#13;Activo2&#10;&#13;Activo3"
                        bind:value={formData.assets}
                        disabled={formData.id}
                        class:is-invalid={shouldShowFieldError($assetsField)}
                    />
                    {#if APIerror}
                        <div class="mt-3 text-danger" style="font-size: 80%;">{APIerror}</div>
                    {/if}
                    {#if shouldShowFieldError($assetsField)}
                        {#if $myForm.hasError('assets.required')}
                            <div class="invalid-feedback">
                                {$format("required")}
                            </div>
                        {/if}
                    {/if}
                </div>

                <div class="mb-3">
                    <label for="description">{$format("page.asset.form.fields.description")}</label>
                    <input
                        type="text"
                        class="form-control t-input-asset-description"
                        id="assetAddDescription"
                        name="description"
                        placeholder={$format("form.fields.description")}
                        bind:value={formData.description}
                    />
                </div>
                <div class="mb-3">
                    <div class="form-check form-switch">
                        <input type="checkbox" bind:this={inputElement} bind:checked="{formData.in_scope}" class="form-check-input" id={"switch_in_scope" + formData.id}>
                        <label class="form-check-input" for={"switch_in_scope" + formData.id}></label>{$format("page.asset.form.fields.in_scope")}
                    </div>

                    {#if !formData.in_scope}
                        <!--@TODO: componentizar -->
                        <div class="alert alert-warning mt-3" role="alert">
                            {#if !asset}
                                {$format("page.asset.form.warnings.out_of_scope")}
                            {/if}
                        </div>
                    {/if}
                </div>
        </div>
        <div class="card-footer">
            <button id="assetAddSubmit" type="submit" class="btn btn-primary t-submit-asset-btn">{$format("buttons.save")}</button>
            <button class="btn btn-default" onclick={handleCloseModal} data-bs-dismiss="modal">{$format("buttons.cancel")}</button>
        </div>
    </div>
</form>
